<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { constructBotFilter } from './helpers/auditTrailFilters';

import Dialog from 'next/dialog/Dialog.vue';
import AuditTrails from 'next/wgpt/AuditTrail/AuditTrails.vue';

const route = useRoute();
const store = useStore();
const { t } = useI18n();

const isOpen = ref(false);
const relativeIds = ref(null);

const auditTrailFilters = computed(() => {
  if (!relativeIds.value) return null;

  return constructBotFilter(route.params.botId, relativeIds.value);
});

const bot = ref({});
const dialogRef = ref(null);

const fetchBotRelativeIds = async () => {
  try {
    const result = await store.dispatch(
      'wgptBots/getRelativeIds',
      bot.value.id
    );
    relativeIds.value = result;
  } catch (error) {
    useAlert(
      error?.message || t('WGPT_BOTS.EDIT.AUDIT_TRAIL.API.ERROR_MESSAGE')
    );
  }
};

const open = selectedBot => {
  bot.value = selectedBot;
  dialogRef.value?.open();
  isOpen.value = true;
  relativeIds.value = null;
  fetchBotRelativeIds(selectedBot.id);
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('WGPT_BOTS.EDIT.AUDIT_TRAIL.TITLE')"
    :description="t('WGPT_BOTS.EDIT.AUDIT_TRAIL.DESCRIPTION')"
    width="3xl"
    :show-confirm-button="false"
    cancel-button-label="Done"
    overflow-y-auto
    @close="isOpen = false"
  >
    <AuditTrails
      v-if="isOpen && auditTrailFilters"
      :filters="auditTrailFilters"
    />
  </Dialog>
</template>
